// Complete Topics Index for JustDoCode Learning Portal
export const topicsIndex = [
  {
    id: 'csharp',
    name: 'C# Programming',
    icon: 'csharp',
    categories: [
      {
        id: 'basics',
        name: 'C# Basics',
        topics: [
          { id: 'introduction', title: 'Introduction to C#' },
          { id: 'setup', title: 'Setting Up C# Environment' },
          { id: 'hello-world', title: 'Hello World Program' },
          { id: 'variables', title: 'Variables & Data Types' },
          { id: 'operators', title: 'Operators' },
          { id: 'type-conversion', title: 'Type Conversion' },
          { id: 'input-output', title: 'Input & Output' },
          { id: 'comments', title: 'Comments' },
          { id: 'constants', title: 'Constants' }
        ]
      },
      {
        id: 'control-flow',
        name: 'Control Flow',
        topics: [
          { id: 'if-else', title: 'If-Else Statements' },
          { id: 'switch', title: 'Switch Statement' },
          { id: 'loops', title: 'Loops (for, while, do-while)' },
          { id: 'break-continue', title: 'Break & Continue' },
          { id: 'goto', title: 'Goto Statement' }
        ]
      },
      {
        id: 'methods',
        name: 'Methods & Functions',
        topics: [
          { id: 'methods-intro', title: 'Introduction to Methods' },
          { id: 'parameters', title: 'Method Parameters' },
          { id: 'return-types', title: 'Return Types' },
          { id: 'method-overloading', title: 'Method Overloading' },
          { id: 'optional-params', title: 'Optional Parameters' },
          { id: 'named-params', title: 'Named Parameters' },
          { id: 'recursion', title: 'Recursion' }
        ]
      },
      {
        id: 'oop',
        name: 'Object-Oriented Programming',
        topics: [
          { id: 'classes-objects', title: 'Classes & Objects' },
          { id: 'constructors', title: 'Constructors' },
          { id: 'properties', title: 'Properties' },
          { id: 'encapsulation', title: 'Encapsulation' },
          { id: 'inheritance', title: 'Inheritance' },
          { id: 'polymorphism', title: 'Polymorphism' },
          { id: 'abstraction', title: 'Abstraction' },
          { id: 'interfaces', title: 'Interfaces' },
          { id: 'abstract-classes', title: 'Abstract Classes' },
          { id: 'static-members', title: 'Static Members' },
          { id: 'sealed-classes', title: 'Sealed Classes' }
        ]
      },
      {
        id: 'collections',
        name: 'Collections & Data Structures',
        topics: [
          { id: 'arrays', title: 'Arrays' },
          { id: 'lists', title: 'Lists' },
          { id: 'dictionaries', title: 'Dictionaries' },
          { id: 'queues', title: 'Queues' },
          { id: 'stacks', title: 'Stacks' },
          { id: 'hashsets', title: 'HashSets' },
          { id: 'linkedlists', title: 'LinkedLists' },
          { id: 'sortedlists', title: 'SortedLists' }
        ]
      },
      {
        id: 'advanced',
        name: 'Advanced C#',
        topics: [
          { id: 'generics', title: 'Generics' },
          { id: 'delegates', title: 'Delegates' },
          { id: 'events', title: 'Events' },
          { id: 'lambda', title: 'Lambda Expressions' },
          { id: 'linq', title: 'LINQ' },
          { id: 'async-await', title: 'Async & Await' },
          { id: 'exception-handling', title: 'Exception Handling' },
          { id: 'file-io', title: 'File I/O' },
          { id: 'attributes', title: 'Attributes' },
          { id: 'reflection', title: 'Reflection' },
          { id: 'threading', title: 'Threading' },
          { id: 'tasks', title: 'Tasks & Parallel Programming' }
        ]
      },
      {
        id: 'modern',
        name: 'Modern C# Features',
        topics: [
          { id: 'nullable-types', title: 'Nullable Types' },
          { id: 'pattern-matching', title: 'Pattern Matching' },
          { id: 'records', title: 'Records' },
          { id: 'init-properties', title: 'Init-only Properties' },
          { id: 'top-level-statements', title: 'Top-level Statements' },
          { id: 'global-usings', title: 'Global Usings' },
          { id: 'file-scoped-namespaces', title: 'File-scoped Namespaces' }
        ]
      }
    ]
  },
  {
    id: 'dotnet',
    name: '.NET Core',
    icon: 'dotnet',
    categories: [
      {
        id: 'fundamentals',
        name: '.NET Fundamentals',
        topics: [
          { id: 'introduction', title: 'Introduction to .NET Core' },
          { id: 'architecture', title: '.NET Architecture' },
          { id: 'cli', title: '.NET CLI' },
          { id: 'project-structure', title: 'Project Structure' },
          { id: 'nuget', title: 'NuGet Package Manager' },
          { id: 'dependency-injection', title: 'Dependency Injection' },
          { id: 'configuration', title: 'Configuration' },
          { id: 'logging', title: 'Logging' }
        ]
      },
      {
        id: 'aspnet-core',
        name: 'ASP.NET Core',
        topics: [
          { id: 'intro', title: 'Introduction to ASP.NET Core' },
          { id: 'mvc', title: 'MVC Pattern' },
          { id: 'routing', title: 'Routing' },
          { id: 'controllers', title: 'Controllers' },
          { id: 'views', title: 'Views & Razor' },
          { id: 'models', title: 'Models' },
          { id: 'model-binding', title: 'Model Binding' },
          { id: 'validation', title: 'Validation' },
          { id: 'filters', title: 'Filters' },
          { id: 'middleware', title: 'Middleware' }
        ]
      },
      {
        id: 'web-api',
        name: 'Web API',
        topics: [
          { id: 'rest-api', title: 'RESTful APIs' },
          { id: 'api-controllers', title: 'API Controllers' },
          { id: 'http-methods', title: 'HTTP Methods' },
          { id: 'status-codes', title: 'Status Codes' },
          { id: 'api-versioning', title: 'API Versioning' },
          { id: 'swagger', title: 'Swagger/OpenAPI' },
          { id: 'authentication', title: 'Authentication' },
          { id: 'authorization', title: 'Authorization' },
          { id: 'jwt', title: 'JWT Tokens' }
        ]
      },
      {
        id: 'entity-framework',
        name: 'Entity Framework Core',
        topics: [
          { id: 'intro', title: 'Introduction to EF Core' },
          { id: 'dbcontext', title: 'DbContext' },
          { id: 'code-first', title: 'Code First Approach' },
          { id: 'migrations', title: 'Migrations' },
          { id: 'relationships', title: 'Relationships' },
          { id: 'querying', title: 'Querying Data' },
          { id: 'crud', title: 'CRUD Operations' },
          { id: 'eager-loading', title: 'Eager Loading' },
          { id: 'lazy-loading', title: 'Lazy Loading' }
        ]
      },
      {
        id: 'testing',
        name: 'Testing',
        topics: [
          { id: 'unit-testing', title: 'Unit Testing' },
          { id: 'xunit', title: 'xUnit' },
          { id: 'nunit', title: 'NUnit' },
          { id: 'moq', title: 'Moq Framework' },
          { id: 'integration-testing', title: 'Integration Testing' },
          { id: 'test-driven-development', title: 'TDD' }
        ]
      },
      {
        id: 'solid-principles',
        name: 'SOLID Principles',
        topics: [
          { id: 'single-responsibility', title: 'Single Responsibility (SRP)' },
          { id: 'open-closed', title: 'Open/Closed (OCP)' },
          { id: 'liskov-substitution', title: 'Liskov Substitution (LSP)' },
          { id: 'interface-segregation', title: 'Interface Segregation (ISP)' },
          { id: 'dependency-inversion', title: 'Dependency Inversion (DIP)' }
        ]
      },
      {
        id: 'design-patterns',
        name: 'Design Patterns',
        topics: [
          { id: 'singleton', title: 'Singleton Pattern' },
          { id: 'factory', title: 'Factory Pattern' },
          { id: 'repository', title: 'Repository Pattern' },
          { id: 'strategy', title: 'Strategy Pattern' },
          { id: 'observer', title: 'Observer Pattern' }
        ]
      },
      {
        id: 'performance',
        name: 'Performance & Security',
        topics: [
          { id: 'caching', title: 'Caching' },
          { id: 'compression', title: 'Response Compression' },
          { id: 'cors', title: 'CORS' },
          { id: 'security-headers', title: 'Security Headers' },
          { id: 'rate-limiting', title: 'Rate Limiting' },
          { id: 'optimization', title: 'Performance Optimization' }
        ]
      },
      {
        id: 'deployment',
        name: 'Deployment',
        topics: [
          { id: 'docker', title: 'Docker Containerization' },
          { id: 'azure', title: 'Azure Deployment' },
          { id: 'iis', title: 'IIS Deployment' },
          { id: 'linux', title: 'Linux Deployment' },
          { id: 'ci-cd', title: 'CI/CD Pipelines' }
        ]
      }
    ]
  }
];

export default topicsIndex;

